import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Stars } from './Stars';
import { testimonials } from '../data/content';
const avatarColors = ['#ff6b57', '#4b8df8', '#ffc83d', '#a07bf7'];
export function LongTestimonials() {
  return <section aria-labelledby="testimonials" className="bg-ink px-5 py-20 sm:py-24" data-id="element-153" data-mp="35taekfi15l55">
      <div className="mx-auto max-w-6xl" data-id="element-154" data-mp="310hbdw27mkv6">
        <h2 id="testimonials" className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase text-white sm:text-4xl" data-id="element-155" data-mp="3fq5b4suqtbgs">
          <HeartIcon className="h-8 w-8 fill-coral text-coral" aria-hidden="true" data-id="element-156" data-mp="3aqakmqevqnw9" />
          Lo que dicen las familias
        </h2>
        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-157" data-mp="3oor1ha6ghus4">
          {testimonials.map((t, i) => <li key={t.name} className="flex flex-col rounded-3xl border border-line bg-surface p-7" data-id="element-158" data-mp="3jpnuhk6x1ehi" data-mpi={i}>
              <Stars className="h-5 w-5" data-id="element-159" data-mp="1uewxbths83y3" />
              <blockquote className="mt-4 text-lg leading-relaxed text-cream" data-id="element-160" data-mp="1peixgyqc40b5">«{t.quote}»</blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-161" data-mp="3p2ztbpdxhmgs">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-base font-black text-ink" style={{
              backgroundColor: avatarColors[i % avatarColors.length]
            }} aria-hidden="true" data-id="element-162" data-mp="3u1b4c3fym30l">
                  {t.initials}
                </span>
                <div className="min-w-0" data-id="element-163" data-mp="bmabn4qmr2y0">
                  <p className="text-base font-black text-white" data-id="element-164" data-mp="bpoba57wsy1r">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-165" data-mp="gkk4h8ovtrgg">{t.location}</p>
                  <p className="text-xs font-bold uppercase tracking-wider text-brand" data-id="element-166" data-mp="ll82iebj38k6">{t.product}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}